export function debounce(a,b,c){var d,e;return function(){function h(){d=null,c||(e=a.apply(f,g))}var f=this,g=arguments;return clearTimeout(d),d=setTimeout(h,b),c&&!d&&(e=a.apply(f,g)),e}}

export function capitalize(str) { return str.charAt(0).toUpperCase() + str.slice(1) }

export function buildQueryString(params) {
  return Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&')
}



// WEBPACK FOOTER //
// ./app/utils/Functions.js